const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/metakat/BehandlungsgrundField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { MessageDescriptor } from '@formatjs/intl';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';


interface Props {
    label: string | MessageDescriptor;
    path: string;
    hidden?: boolean;
    required?: boolean;
}

export const BehandlungsgrundField = forwardRef((props: Props, ref: any) => {
    const { formatMessage, locale } = useIntl();
    const dropdownRef = useCIS4m(ref);
    const label = typeof props.label === 'string' ? props.label : formatMessage(props.label);
    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    return (
        <CIS4mMetaKatDropDown
            ref={dropdownRef}
            label={label}
            path={props.path}
            pcode={'f78d187f-88a6-4666-ba64-2e62aaef5de6'}
            valuePath="FKEY"
            labelPath={`CONTENT.Lang.${locale}`}
            hidden={hidden}
            required={required}
            dataHook={useCIS4FormMetaKatData}
        />
    );
});

BehandlungsgrundField.displayName = 'BehandlungsgrundField';

export default BehandlungsgrundField;
